export default {
  getAssistantSteps: (state) => state.assistantSteps,
  currentStepIndex: (state) => state.currentStepIndex,
  currentStep: (state) => state.assistantSteps[state.currentStepIndex] || {},
  assistantStepsUnique: (state) => {
    const stepsUniqueById = {};
    state.assistantSteps.forEach((step) => {
      if (step.role === "assistant") {
        stepsUniqueById[step.id] = step;
      }
    });
    // Ahora `stepsUniqueById` contiene solo pasos únicos.
    // Convierte esto de nuevo a un array si necesitas un array para la operación de guardado.
    const uniqueStepsArray = Object.values(stepsUniqueById);
    return uniqueStepsArray;
  },
};
